import React from 'react'

import { ProductServices, servicesAdapter } from '@/features/product-services'

import { Modal } from '@/shared/ui'

import { useAppliedServices } from '../../../hooks/use-applied-services'
import { useServicesModal } from '../../../hooks/use-services-modal'
import { AppliedServiceItem } from '../../applied-service-item/applied-service-item'

import cl from './services-section.module.scss'

export type ServicesSectionProps = {
	productId: number
	services: any
	isJuridicalUser: boolean
}

/**
 * Компонент секции управления услугами для товара в корзине
 * Отображает примененные услуги или информацию о доступных услугах
 * Открывает модальное окно со списком всех услуг
 */
export const ServicesSection = ({ productId, services, isJuridicalUser }: ServicesSectionProps): JSX.Element | null => {
	const serviceList = React.useMemo(() => servicesAdapter(services), [services])

	const { appliedServices, activeServiceTitles, hasAppliedServices } = useAppliedServices(productId)
	const { isOpen, openModal, closeModal } = useServicesModal()

	// Не показываем секцию для юридических лиц или если нет услуг
	if (isJuridicalUser || serviceList.length === 0) {
		return null
	}

	return (
		<section className={cl.servicesSection} aria-label="Услуги к товару">
			<h2>Услуги</h2>

			<div className={cl.servicesList}>
				{hasAppliedServices ? (
					appliedServices.map(service => (
						<AppliedServiceItem key={service.ID} service={service} relatedId={productId} />
					))
				) : (
					<ProductServices relatedId={productId} viewType="info" isCart services={serviceList} onClick={openModal} />
				)}
			</div>

			<button className={cl.showAllButton} onClick={openModal} type="button">
				Смотреть все услуги
			</button>

			<Modal isOpen={isOpen} onClose={closeModal} className={cl.modal} contentClassName={cl.modalContent}>
				<ProductServices
					viewType="list"
					services={serviceList}
					relatedId={productId}
					activeServices={activeServiceTitles}
				/>
			</Modal>
		</section>
	)
}
